import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

const StyledCard = styled.div`
  min-width: 400px;
  min-height: 400px;
`;

type GenericTileProps = Readonly<{
  children: ReactNode;
  className?: string;
  subHeader?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
}>;

export const TileLayout: FC<GenericTileProps> = ({ header, footer, subHeader, className, children }) => (
  <StyledCard
    className={classNames('card card-raising card-raised', className)}
    data-e2e="dashboard-tile"
    data-tour="quoteDashboard.tile"
  >
    <div className="card-header p-0">
      {header}
      {subHeader}
    </div>
    <div className="card-body p-0">{children}</div>
    {footer}
  </StyledCard>
);

TileLayout.displayName = 'GenericTile';
